import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';
import { emailNotification } from '../../../../services/other-shipping-options/constants';
import { FormattedMessagePropType } from '../../../../prop-types/intl';
import { BULK_UPDATE_FULFILLMENT_PLAN_ID } from '../../constants';

import { messages } from './messages';
import style from './inputs.module.css';
import { emptyObject } from 'ui-components/default-props/empty';

const updateEmail = (data, value, updateOption) => {
  const newValue = {
    ...data,
    email: value,
  };
  updateOption({ id: emailNotification, value: newValue });
};

const renderEmailInput = (data, updateOption, updateInput) => {
  const { email } = data;
  return (
    <div className={style['single-input']}>
      <Input
        label={<FormattedMessage {...messages.emailLabel} />}
        onBlur={(v) => updateOption(v)}
        onChange={(v) => updateInput(v)}
        value={email}
      />
    </div>
  );
};

export const EmailNotificationOption = ({
  label,
  checked = false,
  fulfillmentPlanId,
  onCheck = noop,
  optionData = emptyObject,
  updateOption = noop,
  updateInput = noop,
}) => {
  const isBulkUpdate = fulfillmentPlanId === BULK_UPDATE_FULFILLMENT_PLAN_ID;

  const handleOnChange = useCallback(
    (isChecked) => {
      let newValue;
      if (isChecked) {
        newValue = {
          useOrderEmail: true,
        };
      }
      updateOption({
        id: emailNotification,
        value: newValue,
        checked: isChecked,
      });
    },
    [updateOption],
  );

  if (isBulkUpdate) {
    return (
      <div>
        <Checkbox checked={checked} label={label} onChange={handleOnChange} />
        <div className={style['notification-option-sublabel']}>
          <FormattedMessage {...messages.emailSublabel} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked &&
        renderEmailInput(
          optionData,
          (email) => updateEmail(optionData, email, updateOption),
          (email) => updateEmail(optionData, email, updateInput),
        )}
    </div>
  );
};

EmailNotificationOption.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.object,
  updateOption: PropTypes.func,
  updateInput: PropTypes.func,
};
